import {StyledProgressbarIndicator, StyledProgressbar} from '@/components/ui/progress-bar/style.ts'
import {FC} from 'react'

export interface ProgressBarProps {
    percentage: number
    rounded?: boolean
    variant?: 'primary' | 'neutral' | 'danger' | 'success'
}

export const ProgressBar: FC<ProgressBarProps> = ({percentage, rounded, variant = 'primary'}) => (
    <StyledProgressbar $rounded={rounded} $variant={variant}>
        <StyledProgressbarIndicator $rounded={rounded} $variant={variant} style={{width: `${percentage}%`}} />
    </StyledProgressbar>
)
